import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("cart") || "[]"); } catch { return []; }
  });

  useEffect(() => { localStorage.setItem("cart", JSON.stringify(items)); }, [items]);

  const addItem = (product, qty, variant = {}) => {
    setItems((prev) => {
      const key = product.slug + JSON.stringify(variant);
      const found = prev.find((i) => i.slug + JSON.stringify(i.variant) === key);
      if (found) {
        return prev.map((i) => (i.slug + JSON.stringify(i.variant) === key ? { ...i, qty: i.qty + qty } : i));
      }
      return [...prev, {
        slug: product.slug, title: product.title_id, image: product.image,
        price_idr: product.price_idr, moq: product.moq, qty, variant,
      }];
    });
  };

  const updateQty = (idx, qty) =>
    setItems((prev) => prev.map((it, i) => (i === idx ? { ...it, qty: Math.max(it.moq, qty) } : it)));
  const removeItem = (idx) => setItems((prev) => prev.filter((_, i) => i !== idx));
  const clear = () => setItems([]);

  const count = items.reduce((s, i) => s + i.qty, 0);
  const subtotal = items.reduce((s, i) => s + i.qty * i.price_idr, 0);

  return (
    <CartContext.Provider value={{ items, addItem, updateQty, removeItem, clear, count, subtotal }}>
      {children}
    </CartContext.Provider>
  );
}
